import styled from 'styled-components';

export const StyledRichTextContainer = styled.div`
  table,
  td,
  th {
    border-collapse: collapse;
    border: 1px solid rgb(174, 193, 204);
  }

  table {
    width: 100%;
    overflow: hidden;
  }

  table tr:nth-child(even) {
    background-color: #f2f2f2;
  }

  table tr:nth-child(odd) {
    background-color: #ffffff;
  }

  td {
    p {
      margin: 5px;
      padding: 0;
      text-align: center;
    }
  }
`;
